import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { com } from '@eidu/form'
import EntityPicker from '../../../../components/input/EntityPicker'
import { getKnownKindKey, kindDefinitions } from '../../../../domain/kindRegistry'
import EntityId = com.eidu.sharedlib.entity.EntityId
import EntityTypeKind = com.eidu.sharedlib.entity.type.EntityTypeKind

const isAssetKind = (kind: EntityTypeKind) => {
  const key = getKnownKindKey(kind)
  return key !== undefined && kindDefinitions[key].sidebarGroup === 'asset'
}

type AssetReferencePickerProps = {
  open: boolean
  value: EntityId | undefined
  onChange: (entityId: EntityId | undefined) => void
  onConfirm: () => void
  onCancel: () => void
}

const AssetReferencePicker = ({ open, value, onChange, onConfirm, onCancel }: AssetReferencePickerProps) => (
  <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
    <DialogTitle>Insert Asset Reference</DialogTitle>
    <DialogContent sx={{ overflow: 'visible', paddingTop: '16px !important' }}>
      <EntityPicker value={value} onChange={onChange} kindFilter={isAssetKind} />
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel}>Cancel</Button>
      <Button variant="contained" onClick={onConfirm} disabled={!value}>
        Insert
      </Button>
    </DialogActions>
  </Dialog>
)

export default AssetReferencePicker
